import moment from 'moment';
import React from 'react';
import Cell from './Cell';
import styles from './MonthView.css';

const MonthView = ({ className = '', date, events, onNavigate }) => {
  const startMonth = moment(date).startOf('month');
  const endMonth = moment(date).endOf('month');
  const currentWeek = startMonth.clone().startOf('week');

  const weeks = [];
  while (currentWeek.isBefore(endMonth)) {
    const days = [];
    const startWeek = currentWeek.clone().startOf('week');
    const endWeek = currentWeek.clone().endOf('week');
    const currentDay = startWeek.clone();
    while (currentDay.isBefore(endWeek)) {
      days.push({
        date: currentDay.format(),
        events: events.filter(
          (e) =>
            !currentDay.isBefore(e.startDate) && !currentDay.isAfter(e.endDate)
        ),
        inactive:
          currentDay.isBefore(startMonth) || currentDay.isAfter(endMonth)
      });
      currentDay.add(1, 'day');
    }
    weeks.push(days);
    currentWeek.add(1, 'week');
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.headerRow}>
        <div className={styles.headerLabel}>Sunday</div>
        <div className={styles.headerLabel}>Monday</div>
        <div className={styles.headerLabel}>Tuesday</div>
        <div className={styles.headerLabel}>Wednesday</div>
        <div className={styles.headerLabel}>Thursday</div>
        <div className={styles.headerLabel}>Friday</div>
        <div className={styles.headerLabel}>Saturday</div>
      </div>
      {weeks.map((days, i) => (
        <div className={styles.week} key={i}>
          {days.map(({ date, events, inactive }) => (
            <Cell
              date={date}
              events={events}
              inactive={inactive}
              key={date}
              onClick={() => onNavigate(date, 'day')}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default MonthView;
